import { AlertClassKey } from '@material-ui/lab/Alert';

const MuiAlert = (): Partial<Record<AlertClassKey, unknown>> => ({
    outlinedWarning: {
        borderWidth: 0,
        borderLeftWidth: 8,
    },
    outlinedInfo: {
        borderWidth: 0,
        borderLeftWidth: 8,
    },
    outlinedSuccess: {
        borderWidth: 0,
        borderLeftWidth: 8,
    },
    outlinedError: {
        borderWidth: 0,
        borderLeftWidth: 8,
    },
});

export default MuiAlert;
